import { useFormikContext, getIn } from "formik";
import { CheckboxField } from "./CheckboxField";
import { IVehicle } from "../../../../../types/vehicle.type";
import { UploadDocumentFieldFormik } from "@/modules/renters/components/forms/fields/UploadDocumentFieldFormik";
import { UploadImageField } from "@/common/components/form/UploadImageField/UploadImageField";

type PreparationItemProps = {
  name: keyof Omit<
    IVehicle["vehiclePreparing"],
    | "preparation"
    | "repreparation"
    | "crlvDocument"
    | "nfDocument"
    | "trackerValidation"
    | "insuranceStatus"
  >;
  label: string;
  className?: string;
  pathToUpload: string;
  isReadOnly?: boolean;
};

export function PreparationItem({
  name,
  label,
  className,
  pathToUpload,
  isReadOnly = false,
}: PreparationItemProps) {
  const { values, setFieldValue } = useFormikContext<IVehicle>();

  const isChecked = getIn(values, `vehiclePreparing.${name}`);

  const handleCheckboxChange = () => {
    const newCheckedState = !isChecked;
    setFieldValue(`vehiclePreparing.${name}`, newCheckedState);

    const currentPreparation =
      getIn(values, "vehiclePreparing.preparation") || {};

    if (newCheckedState) {
      setFieldValue("vehiclePreparing.preparation", {
        ...currentPreparation,
        [name]: { beforeImage: "", afterImage: "" },
      });
    } else {
      const newPreparation = { ...currentPreparation };
      delete newPreparation[name];
      setFieldValue("vehiclePreparing.preparation", newPreparation);
    }
  };

  return (
    <div className={`py-2 ${className}`}>
      <CheckboxField
        name={`vehiclePreparing.${name}`}
        label={label}
        checked={isChecked}
        disabled={isReadOnly || isChecked}
        onChange={handleCheckboxChange}
      />

      {isChecked && (
        <div className="mt-2 pl-6 grid grid-cols-1 md:grid-cols-2 gap-4 border-l-2 border-gray-200">
          <div>
            <p className="text-sm font-medium mb-1">Antes:</p>
            <UploadDocumentFieldFormik
              name={`vehiclePreparing.preparation.${name}.beforeImage`}
              pathToUpload={pathToUpload}
            >
              {({ src, onNewFile, onRemoveClick }) => (
                <UploadImageField
                  src={src}
                  onNewFile={onNewFile}
                  onRemoveClick={onRemoveClick}
                  isReadOnly={isReadOnly}
                />
              )}
            </UploadDocumentFieldFormik>
          </div>
          <div>
            <p className="text-sm font-medium mb-1">Depois:</p>
            <UploadDocumentFieldFormik
              name={`vehiclePreparing.preparation.${name}.afterImage`}
              pathToUpload={`vehicles/${values._id}/preparation/${name}`}
            >
              {({ src, onNewFile, onRemoveClick }) => (
                <UploadImageField
                  src={src}
                  onNewFile={onNewFile}
                  onRemoveClick={onRemoveClick}
                  isReadOnly={isReadOnly}
                />
              )}
            </UploadDocumentFieldFormik>
          </div>
        </div>
      )}
    </div>
  );
}
